import React, { useEffect, useState } from "react";
import Footer from "../../component/Footer";
import Header from "../../component/Header";
import "../../assets/style/shop.css";
import {
  premium1,
  premium2,
  premium3,
  smallafter,
  smallbefore,
} from "../../constant/index";
import { Link } from "react-router-dom";
import { GetAllFilterApi, GetPlantsApi } from "../../network/Network";
import Skeleton from "react-loading-skeleton";
import NoRecord from "../../component/NoRecord/NoRecord";
import AllPlantCard from "../../component/AllCard/AllPlantCard";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";

const PremiumProducts = () => {
  const CategoriesReduxData = useSelector(
    (state) => state.AuthReducer.categories
  );
  const [productsData, setProductsData] = useState([]);
  const [spinLoad, setSpinLoad] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState();

  const [startPrice, setStartPrice] = useState("");
  const [endPrice, setEndPrice] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filtersData, setFiltersData] = useState([]);
  const [search, setSearch] = useState("");

  const handlePageClick = async (data) => {
    setCurrentPage(data?.selected + 1);
  };

  const ApplyFilters = (e = null, type) => {
    if (e) {
      e.preventDefault();
    }
    setSpinLoad(true);
    let data;
    if (type == "reset") {
      data = {
        name: "/other-products",
        start_price: " ",
        end_price: " ",
        category: " ",
        search: " ",
      };
      window.location.reload(false);
      setStartPrice("");
      setEndPrice("");
      setSelectedCategory("");
      setSearch("");
    } else {
      data = {
        name: "/other-products",
        start_price: type == "search" ? " " : startPrice,
        end_price: type == "search" ? " " : endPrice,
        category: type == "search" ? " " : selectedCategory,
        search: type == "filter" ? " " : search,
      };
    }
    GetPlantsApi(currentPage,data)
      .then((res) => {
        // console.log(res);
        setProductsData(res?.data?.data);
        const total = res?.data?.total;
        const limit = res?.data?.per_page;
        setPageCount(Math.ceil(total / limit));
        setSpinLoad(false);
      })
      .catch((err) => {
        // console.log(err);
        setSpinLoad(false);
      });
  };

  // Get ALL Products
  useEffect(() => {
    ApplyFilters(null);
  }, [currentPage]);

  // Get FILTERS Data
  useEffect(() => {
    GetAllFilterApi()
      .then((res) => {
        // console.log("filter ", res);
        setFiltersData(res?.data);
      })
      .catch((err) => {
        // console.log(err);
      });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      {/* <!-- InnerBanner Sec Start Here --> */}
      <section className="innerBanner">
        <div className="container">
          <div className="inner-box">
            <div className="title">
              <h2>premium ProductS</h2>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- InnerBanner Sec End Here --> */}

      {/* <!-- Shop Sec Start Here --> */}
      <section className="shop_sec otherProducts">
        <div className="before">
          <figure>
            <img src={smallafter} className="img-fluid" />
          </figure>
        </div>
        <div className="container">
          
        {CategoriesReduxData?.map((item, index) => {
            return (
              <>
                {item?.name == "Other Products" ? (
                  <div className="heading" key={index}>
                  <h2>{item?.subtitle}</h2>
                </div>
                ) : null}
              </>
            );
          })}
          <div className="row">
            <div className="col-lg-3">
              <div className="sidebar">
                <div className="heading">
                  <h3>Apply Filters</h3>
                </div>
                <div className="search">
                  <form action="">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <button
                      className="searchBtn"
                      type="submit"
                      onClick={(e) => ApplyFilters(e, "search")}
                    >
                      <i className="fa fa-search" aria-hidden="true"></i>
                    </button>
                  </form>
                </div>
                <div className="filter">
                  <div className="box">
                    <div className="title">
                      <h4>Category</h4>
                    </div>
                    <div>
                      <select
                        className="form-control"
                        id="state"
                        name="state"
                        onChange={(e) => {
                          setSelectedCategory(e.target.value);
                        }}
                      >
                        <option selected="">Select Category</option>
                        {filtersData?.sub_category?.map((item, index) => {
                          return (
                            <option value={item?.id} key={index}>
                              {item?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="price-range">
                    <div className="title">
                      <h4>Price</h4>
                    </div>
                    <div className="input-group">
                      <div className="form-group">
                        <label for="From">From</label>
                        <input
                          type="text"
                          id="From"
                          className="form-control"
                          placeholder="From"
                          value={startPrice}
                          onChange={(e) => setStartPrice(e.target.value)}
                        />
                      </div>
                      <div className="seprator"></div>
                      <div className="form-group">
                        <label for="To">To</label>
                        <input
                          type="text"
                          id="To"
                          className="form-control"
                          placeholder="To"
                          value={endPrice}
                          onChange={(e) => setEndPrice(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 mb-3">
                    <button
                      className="apply-filter-btn"
                      onClick={(e) => ApplyFilters(e, "filter")}
                    >
                      Apply Filters
                    </button>
                  </div>

                  <div className="mt-3 mb-3">
                    <button
                      className="apply-filter-btn"
                      onClick={(e) => ApplyFilters(e, "reset")}
                    >
                      Reset Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="row">
                {spinLoad ? (
                  <>
                    {[0, 1, 2, 3, 4, 5]?.map((item, index) => {
                      return (
                        <div className="col-md-4 mt-3" key={index}>
                          <Skeleton count={5} />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {productsData?.length > 0 ? (
                      <>
                        {productsData?.map((item, index) => {
                          return (
                            <AllPlantCard
                              item={item}
                              index={index}
                              colValue={"4"}
                              links={`/premium-product`}
                            />
                          );
                        })}
                      </>
                    ) : (
                      <NoRecord />
                    )}
                  </>
                )}
              </div>
              <div className="paginatio-count">
                <div className="pagination-container mt-5">
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    breakLabel={"..."}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
                {productsData?.length > 0 ? (
                  <p className="total-pages">
                    {productsData?.length} PRODUCTS 1 - {productsData?.length}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="after">
          <figure>
            <img src={smallbefore} className="img-fluid" />
          </figure>
        </div>
      </section>
      {/* <!-- Shop Sec End Here --> */}
      <Footer />
    </>
  );
};

export default PremiumProducts;
